/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: hooks\useDeviceModelsData.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the Provisioning Device Models module.
────────────────────────────────────────────────────────────────*/

import { useState, useEffect, useCallback } from 'react';
import * as api from '../api';

export function useDeviceModelsData() {
    const [vendors, setVendors] = useState<api.Vendor[]>([]);
    const [models, setModels] = useState<api.DeviceModel[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const refresh = useCallback(async () => {
        setLoading(true);
        try {
            const [v, m] = await Promise.all([
                api.getVendors(),
                api.getDeviceModels()
            ]);
            setVendors(v || []);
            setModels(m || []);
            setError(null);
        } catch (err) {
            console.error(err);
            setError(err instanceof Error ? err.message : 'Failed to fetch data');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    return { vendors, models, loading, error, refresh };
}
